import { useCallback, useMemo } from "react"

import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useTokenFactory = ({ fetch, collections: { collectionsURL }, siteSelected: { key, id } }) => {
  const getSession = useCallback(() => fetch({
    url: `${collectionsURL}/sessions`,
    params: {
      [key]: id,
    },
  }), [fetch, collectionsURL, id, key])

  const deleteSessions = useCallback(sessions => fetch({
    url: `${collectionsURL}/sessions`,
    method: 'post',
    data: {
      sessions,
      [key]: id,
    },
  }), [collectionsURL, fetch, id, key])

  return useMemo(() => ({
    session: {
      getSession,
      deleteSessions,
    },
  }), [getSession, deleteSessions])
}

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('site_id'))
  .extendHookCollectionFactory('token')
  .extendHookCollectionsFactory('tokens')
  .extend(useTokenFactory)
  .factory()

export {
  Provider as TokenProvider,
  useStore as useTokenStore,
}
